import Link from "next/link";
import React from "react";
import { motion } from "framer-motion";
import { BsArrowRight } from "react-icons/bs";

interface Project {
  title: string;
  slug: string;
  summary?: string;
  content?: string;
  coverImageUrl?: string;
  tags?: string[];
  sections?: ProjectSection[];
  createdAt: Date;
  updatedAt: Date;
}
interface ProjectSection {
  type: string; // e.g., 'hero', 'text'
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
}

export default function ProjectList(
  { projects }: { projects: Project[] | undefined } = {
    projects: [
      {
        slug: "sample-project",
        title: "Sample Project",
        summary: "A brief description of the project",
        content: "This is a sample project.",
        tags: ["React", "TypeScript"],
        sections: [],
        createdAt: new Date(),
        updatedAt: new Date(),
      },
    ],
  }
) {
  return (
    <div className="container ">
      {projects!.map((project) => (
        <Link
          key={project.slug}
          href={`/projects/${project.slug}`}
          className=""
        >
          <motion.div
            className="position-relative"
            style={{
              width: "100%",
              height: 300,
              borderRadius: 10,
              overflow: "hidden",
              marginBottom: 20,
              willChange: "transform",
            }}
            initial="rest"
            animate="rest"
            whileHover="hover"
            variants={{
              rest: { scale: 1 },
              hover: { scale: 1.02 },
            }}
            transition={{ type: "spring", stiffness: 260, damping: 20 }}
          >
            {/* Background image layer (zooms on hover) */}
            <motion.div
              aria-hidden
              className="position-absolute w-100 h-100"
              style={{
                backgroundImage: `url(${project.coverImageUrl ?? ""})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                inset: 0,
              }}
              variants={{
                rest: { scale: 1 },
                hover: { scale: 1.08 },
              }}
              transition={{ type: "tween", duration: 0.35, ease: "easeOut" }}
            />

            {/* Dark overlay (darkens on hover) */}
            <motion.div
              aria-hidden
              className="position-absolute w-100 h-100"
              style={{ inset: 0, backgroundColor: "rgba(0,0,0,0.45)" }}
              variants={{
                rest: { backgroundColor: "rgba(0,0,0,0.45)" },
                hover: { backgroundColor: "rgba(0,0,0,0.7)" },
              }}
              transition={{ type: "tween", duration: 0.3, ease: "easeOut" }}
            />

            {/* Content layer */}
            <div className="d-flex flex-column justify-content-center align-items-center position-relative h-100">
              <h1 className="text-white mb-1 mt-5 pt-5 px-3">{project.title}</h1>
              <div className="divider-gradient mb-1 w-100" />
              <p className="text-white px-3 flex-grow-1" style={{ maxWidth: "80%" }}>
                {project.summary}
              </p>
              <div className="d-flex justify-content-end align-items-center w-100 px-3 pb-3">
                View Details <BsArrowRight className="ps-1" />
              </div>
            </div>
          </motion.div>
        </Link>
      ))}
    </div>
  );
}
